[
  {
    "pageName": "Home",
    "hasChildren": false,
    "route": "/main/landing-page",
    "icon": "landing-page",
    "ref": "landing-page",
    "menuGroup": "menu"
  },
  {
    "pageName": "Settings",
    "hasChildren": true,
    "route": null,
    "icon": "settings",
    "ref": "settings",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Voicebot Settings",
        "hasChildren": false,
        "route": "/main/voicebot-settings",
        "icon": "microphone",
        "ref": "voicebot-settings"
      },
      {
        "pageName": "AI Configs",
        "hasChildren": false,
        "route": "/main/ai-configs",
        "icon": "robot",
        "ref": "ai-configs"
      },
      {
        "pageName": "LLM Agents",
        "hasChildren": false,
        "route": "/main/llm-agents",
        "icon": "workflow",
        "ref": "llm-agents"
      },
      {
        "pageName": "InBound Settings",
        "hasChildren": false,
        "route": "/main/inbound-settings",
        "icon": "settings",
        "ref": "inbound-settings"
      },
      {
        "pageName": "OutBound Settings",
        "hasChildren": false,
        "route": "/main/outbound-settings",
        "icon": "settings",
        "ref": "outbound-settings"
      }
    ]
  },
  {
    "pageName": "Noise Word Handling",
    "hasChildren": true,
    "route": "/main/noise-word-handling",
    "icon": "screening",
    "ref": "noise-word-handling",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Library",
        "hasChildren": false,
        "route": "/main/noise-word-handling/library",
        "icon": "list",
        "ref": "noise-word-library"
      },
      {
        "pageName": "Logs",
        "hasChildren": false,
        "route": "/main/noise-word-handling/logs",
        "icon": "file",
        "ref": "noise-word-logs"
      }
    ]
  },
  {
    "pageName": "Out of Scope Questions",
    "hasChildren": false,
    "route": "/main/out-of-scope-questions",
    "icon": "alerts",
    "ref": "out-of-scope-questions",
    "menuGroup": "pages"
  },
  {
    "pageName": "Contacts",
    "hasChildren": false,
    "route": "/main/contacts",
    "icon": "accounts",
    "ref": "contacts",
    "menuGroup": "pages"
  },
  {
    "pageName": "KPIs",
    "hasChildren": false,
    "route": "/main/landing-page",
    "icon": "analytics",
    "ref": "kpis",
    "menuGroup": "pages"
  },
  {
    "pageName": "Avatar Configuration",
    "hasChildren": true,
    "isActive": true,
    "route": "/main/avatar-configuration",
    "icon": "accounts",
    "ref": "avatar-configuration",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Personalization",
        "ref": "avatar-configuration/personalization",
        "route": "/main/avatar-configuration/personalization"
      },
      {
        "pageName": "Avatar Settings",
        "ref": "avatar-configuration/speech",
        "route": "/main/avatar-configuration/speech"
      }
    ]
  },
  {
    "pageName": "Program Management",
    "hasChildren": true,
    "route": "/main/program-management",
    "icon": "workflow",
    "ref": "program-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Programs",
        "hasChildren": false,
        "route": "/main/program-management/programs",
        "icon": "list",
        "ref": "program"
      },
      {
        "pageName": "Programs Stages",
        "hasChildren": false,
        "route": "/main/program-management/program-stages",
        "icon": "list",
        "ref": "program-stages"
      },
      {
        "pageName": "Subjects",
        "hasChildren": false,
        "route": "/main/program-management/subjects",
        "icon": "list",
        "ref": "subjects"
      },
      {
        "pageName": "Topics",
        "hasChildren": false,
        "route": "/main/program-management/topics",
        "icon": "list",
        "ref": "topics"
      },
      {
        "pageName": "Learning Objectives",
        "hasChildren": false,
        "route": "/main/program-management/learning-objectives",
        "icon": "list",
        "ref": "learning-objectives"
      }
    ]
  },
  {
    "pageName": "Learner Management",
    "hasChildren": true,
    "route": "/main/learner-management",
    "icon": "accounts",
    "ref": "learner-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Learners",
        "hasChildren": false,
        "route": "/main/learner-management/learners",
        "icon": "list",
        "ref": "learners"
      },
      {
        "pageName": "Program Enrollments",
        "hasChildren": false,
        "route": "/main/learner-management/program-enrollments",
        "icon": "list",
        "ref": "program-enrollments"
      },
      {
        "pageName": "Course Enrollments",
        "hasChildren": false,
        "route": "/main/learner-management/course-enrollments",
        "icon": "list",
        "ref": "course-enrollments"
      }
    ]
  },
  {
    "pageName": "Course Management",
    "hasChildren": true,
    "route": "/main/course-management",
    "icon": "analytics",
    "ref": "course-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Courses",
        "hasChildren": false,
        "route": "/main/course-management/courses",
        "icon": "list",
        "ref": "courses"
      }
    ]
  },
  {
    "pageName": "InBound Calls",
    "hasChildren": true,
    "route": "/main/inbound",
    "icon": "analytics",
    "ref": "inbound",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "InBound Calls",
        "hasChildren": false,
        "route": "/main/inbound/customer-loan-view",
        "icon": "list",
        "ref": "inbound/customer-loan-view"
      }
    ]
  },
  {
    "pageName": "Out Bound Calls",
    "hasChildren": true,
    "route": "/main/outbound",
    "icon": "analytics",
    "ref": "outbound",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Out Bound Calls",
        "hasChildren": false,
        "route": "/main/outbound/customer-loan-view",
        "icon": "list",
        "ref": "outbound/customer-loan-view"
      }
    ]
  },
  {
    "pageName": "Active Calls",
    "hasChildren": false,
    "route": "/main/active-calls",
    "icon": "analytics",
    "ref": "active-calls",
    "menuGroup": "pages"
  },
  {
    "pageName": "Agents",
    "hasChildren": false,
    "route": "/main/agents",
    "icon": "accounts",
    "ref": "agents",
    "menuGroup": "pages"
  },
  {
    "pageName": "Campaigns",
    "hasChildren": true,
    "route": "/main/campaign",
    "icon": "workflow",
    "ref": "campaign",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Campaign List",
        "hasChildren": false,
        "route": "/main/campaign/list",
        "icon": "list",
        "ref": "campaign/list"
      }
    ]
  },
  {
    "pageName": "Guardian Management",
    "hasChildren": true,
    "route": "/main/guardian-management",
    "icon": "accounts",
    "ref": "guardian-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Guardians",
        "hasChildren": false,
        "route": "/main/guardian-management/guardians",
        "icon": "list",
        "ref": "guardians"
      },
      {
        "pageName": "Relationships",
        "hasChildren": false,
        "route": "/main/guardian-management/learner-guardian-relationships",
        "icon": "list",
        "ref": "learner-guardian-relationships"
      }
    ]
  },
  {
    "pageName": "Company Management",
    "hasChildren": true,
    "route": "/main/company-management",
    "icon": "case-management",
    "ref": "company-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Companies",
        "hasChildren": false,
        "route": "/main/company-management/company-list",
        "icon": "list",
        "ref": "companies"
      },
      {
        "pageName": "Interns",
        "hasChildren": false,
        "route": "/main/company-management/intern-list",
        "icon": "list",
        "ref": "intern-list"
      }
    ]
  },
  {
    "pageName": "Instructor Management",
    "hasChildren": true,
    "route": "/main/instructor-management",
    "icon": "accounts",
    "ref": "instructor-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Instructors",
        "hasChildren": false,
        "route": "/main/instructor-management/instructors",
        "icon": "list",
        "ref": "instructors"
      }
    ]
  },
  {
    "pageName": "User Management",
    "hasChildren": true,
    "route": null,
    "icon": "user-management",
    "ref": "user-management",
    "menuGroup": "general",
    "children": [
      {
        "pageName": "User",
        "ref": "user-management/user-list",
        "route": "/main/user-management/user-list"
      },
      {
        "pageName": "Role",
        "ref": "user-management/roles",
        "route": "/main/user-management/roles"
      },
      {
        "pageName": "User Role Mapping",
        "ref": "user-management/user-role-mapping",
        "route": "/main/user-management/user-role-mapping"
      },
      {
        "pageName": "User Group",
        "ref": "user-management/user",
        "route": "/main/user-management/user-groups"
      },
      {
        "pageName": "Master Management",
        "ref": "master-management-v2",
        "route": "/main/master-management-v2"
      }
    ]
  }
]
